import { useCanvasStore } from '../store/canvas-store';
import { usePanelStore } from './panel/panel-store';
import { shortId } from './dropDetect';

/** Starter source for a new TSX component frame. */
export const STARTER_TSX = `import { Button, Card, CardContent } from '@/ui';

export const props = {
  label: { type: 'text', default: 'Click me' },
};

export default function Frame({ label }: { label: string }) {
  return (
    <Card>
      <CardContent className="p-6">
        <Button>{label}</Button>
      </CardContent>
    </Card>
  );
}`;

/**
 * Spawn a starter TSX component frame at the given world coords (defaults to a
 * fixed canvas spot), select it, and open the Editor Panel so the user lands in
 * the source editor. Shared by the ⌘P palette and the canvas context menu.
 */
export function spawnTsxComponent(x = 80, y = 80): string {
  const id = shortId();
  useCanvasStore.getState().dispatch({
    t: 'tsxFrame.create',
    id,
    x,
    y,
    w: 320,
    title: 'Component',
    tsx: STARTER_TSX,
  });
  useCanvasStore.getState().dispatch({ t: 'select', ids: [id] });
  usePanelStore.getState().setOpen(true);
  return id;
}
